if (module) module.exports = (function (win) {
  var bridge = {},
      callbackID = 0,
      httpRequestCallback = undefined,
      methods = [],
      invokes = [],
      callbacks = [];
  // 是否可使用AHJavascriptBridge
  function isAvailable() {
      return typeof (window.AHJavascriptBridge) !== 'undefined';
  }
  bridge = {
      // 绑定提供给原生调用的js方法
      bindMethod: function (methodName, callback) {
          if (isAvailable()) {
              window.AHJavascriptBridge.bindMethod(methodName, callback);
          } else {
              methods.push({
                  command: methodName,
                  fn: callback
              });
          }
          return this;
      },
      // 调用原生提供的方法
      invoke: function (methodName, args, callback) {
          if (isAvailable()) {
              window.AHJavascriptBridge.invoke(methodName, args, callback);
          } else {
              invokes.push({
                  method: methodName,
                  args: args,
                  callback: callback
              });
          }
          return this;
      },
      // 原生httpRequest
      httpRequest: function (options) {
          function fn() { }
          var settings = options || {};
          var args = {},
              dataType = settings.dataType || '',
              callbackName = 'callback' + (++callbackID),
              success = settings.success || fn,
              error = settings.error || fn;
          callbacks[callbackName] = {
              success: success,
              error: error
          };
          args.method = settings.type || 'GET';
          args.url = settings.url || window.location.toString();
          args.headers = settings.headers || {};
          args.params = settings.data || {};
          args.callback = callbackName;
          httpRequestCallback || (httpRequestCallback = bridge.bindMethod('httpRequestCallback', function (result) {
              if (result && 'callback' in result) {
                  var callback = callbacks[result.callback];
                  var data = result.responseText && dataType == "json" && JSON.parse(result.responseText) || result;
                  if (data.returncode > -1) {
                      callback.success(data);
                  } else {
                      var errormessage = data.message || '请求失败，请稍候重试';
                      callback.error(errormessage);
                  }
                  delete callbacks[result.callback];
              }
          }));
          bridge.invoke('httpRequest', args);
      },
      // 根据方法名判断APP里是否已经定义方法
      isBindMethod: function (methodName, callback) {
          if (bridge.isAvailable()) {
              bridge.invoke('getNativeBindMethods', null, function (args) {
                  var methods = args.result;
                  if (methods && typeof (methods) !== 'undefined') {
                      callback(methods.indexOf(methodName) > -1);
                  }
              });
          } else {
              callback(false);
          }
      },
      //分享
      share: function (options) {
          this.invoke('sharePage', options);
      },
      /**
       * 模态框
       */
      dialog: function (options, callback) {
          this.invoke('showDialog', options, null);
          this.bindMethod('dialogResult', function (result) {
              callback(result);
          });
      },
      //code：0-关闭当前页面 1关闭当前页面并刷新上一级页面
      closePage: function (options) {
          this.invoke('showDialog', options, null);
      },
      isAvailable: function () {
          return isAvailable();
      }
  };
  win.onBridgeReady = function () {
      if (!isAvailable()) return false;
      var temp;
      while ((temp = methods.shift())) {
          window.AHJavascriptBridge.bindMethod(temp.command, temp.fn);
      }
      while ((temp = invokes.shift())) {
          window.AHJavascriptBridge.invoke(temp.method, temp.args, temp.callback);
      }
  };
  return bridge;
})(window);



// WEBPACK FOOTER //
// ./src/util/appbridge.js